import React from 'react';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import { FormikProvider, Form, useFormik } from 'formik';
import { Button, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { CloseIcon } from '@/common/icons/CloseIcon';

import { MIconButton } from '../../../../../../../../@material-extend';
import { useUpdatePrimaryPaymentMethod } from '@/api/finance/staff';

const PrimaryCardModal = (props: any) => {
  const { refreshCardList, selectedItem, setIsModalOpen, setDefaultGateway } =
    props;
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { mutateAsync: updatePrimaryPaymentMethodMutation } =
    useUpdatePrimaryPaymentMethod();

  const initialValues = {
    paymentMethodId: selectedItem?.paymentMethodId
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async values => {
      await updatePrimaryPaymentMethodMutation({
        id: values.paymentMethodId
      });

      enqueueSnackbar('Primary Card Updated Succesfully!', {
        variant: 'success',
        action: (key: any) => (
          <MIconButton size="small" onClick={() => closeSnackbar(key)}>
            <CloseIcon />
          </MIconButton>
        )
      });
      setIsModalOpen(false);
      // Refetch both card list and default payment
      refreshCardList();
      setDefaultGateway();
    }
  });

  const { handleSubmit, isSubmitting } = formik;

  return (
    <Dialog open={true} onClose={() => setIsModalOpen(false)}>
      <FormikProvider value={formik}>
        <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
          <DialogTitle
            style={{
              color: 'white',
              padding: '10px',
              textAlign: 'center',
              backgroundColor: '#003f5c'
            }}
          >
            Confirm Primary Card
          </DialogTitle>
          <DialogContent>
            {`Set card ending in ${selectedItem?.last4} as your primary card?`}
          </DialogContent>
          <div
            style={{
              width: '100%',
              padding: '10px',
              display: 'flex',
              background: '#fafafa',
              justifyContent: 'flex-end'
            }}
          >
            <Button
              type="button"
              color="primary"
              variant="outlined"
              style={{ marginRight: '5px' }}
              onClick={() => setIsModalOpen(false)}
            >
              Close
            </Button>
            <LoadingButton
              type="submit"
              color="primary"
              variant="contained"
              loading={isSubmitting}
            >
              Save
            </LoadingButton>
          </div>
        </Form>
      </FormikProvider>
    </Dialog>
  );
};

export default PrimaryCardModal;
